import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SessionService } from '../../service/session.service';
import { ViewEncapsulation } from '@angular/core';
import { FormationService } from '../../service/formation.service';
import { Formation } from '../../model/formation.model';

@Component({
  selector: 'app-progress-gauge',
  templateUrl: './progress-gauge.component.html',
  styleUrls: ['./progress-gauge.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgressGaugeComponent implements OnInit, OnChanges {
  @Input() formation!: Formation;
  // Minutes supplémentaires à ajouter dynamiquement à should_be_assigned (ex: durée session courante * minutes_exercices_per_visio)
  @Input() extraShouldBeAssigned: number = 0;

  progress: number = 0; // Valeur en pourcentage
  totalTime: number = 0; // Temps total utilisé
  duration: number = 0; // Durée totale des exercices assignés
  totalHoursToDo: number = 0; // Total des heures à faire sur toute la formation

  constructor(
    private formationService: FormationService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.getAssignedExercisesDuration();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["extraShouldBeAssigned"] && !changes["extraShouldBeAssigned"].firstChange) {
      // Recalculer le progrès avec la nouvelle valeur
      this.recomputeProgress();
    }
  }

  getAssignedExercisesDuration() {
    this.formationService.getFormationExercicesInfo(this.formation.id).subscribe({
      next: (exerciceInfos) => {
        this.totalTime = exerciceInfos.total_assigned.duration;
        const baseShouldBeAssigned = exerciceInfos.should_be_assigned ? Math.ceil(exerciceInfos.should_be_assigned) : 0;
        this.duration = baseShouldBeAssigned + (this.extraShouldBeAssigned || 0);
        this.progress = this.duration ? (this.totalTime / this.duration) * 100 : 0;
        this.totalHoursToDo = exerciceInfos.total_hours_to_do || 0;
        this.cdr.markForCheck();
      },
    });
  }

  private recomputeProgress() {
    // On ne relance pas l'appel HTTP; on ajuste seulement la cible si déjà chargée
    if (this.duration || this.duration === 0) {
      // duration actuelle = base + ancienne extra; on ne connaît pas la base séparément.
      // Pour précision, on recharge si aucune data encore.
      this.getAssignedExercisesDuration();
    } else {
      this.getAssignedExercisesDuration();
    }
  }
}
